import React, { useState } from 'react'
import axios from 'axios'
import EstimatePreviewPage from './EstimatePreviewPage'

const TestHarness = () => {
  const [input, setInput] = useState('')
  const [data, setData] = useState(null)
  const [loading, setLoading] = useState(false)
  const [exporting, setExporting] = useState(false)
  const [error, setError] = useState(null)

  const handleLoad = () => {
    const val = input.trim()
    if (!val) return

    setLoading(true)
    setError(null)
    setData(null)

    axios.get(`/api/proposal/preview-data/${val}`)
      .then(res => {
        setData(res.data)
      })
      .catch(err => {
        setError(err.response?.data?.message || 'Failed to load estimate')
      })
      .finally(() => setLoading(false))
  }

  const handleExportPdf = () => {
    const id = data?.estimate?._id
    if (!id) return

    setExporting(true)
    axios.post(`/api/proposal/generate-pretty-pdf/${id}`, {}, { responseType: 'blob' })
      .then(res => {
        const blob = new Blob([res.data], { type: 'application/pdf' })
        const url = window.URL.createObjectURL(blob)
        const a = document.createElement('a')
        a.href = url
        const clientName = data.client?.displayName || data.client?.firstName || 'Estimate'
        const estNum = data.estimate?.number || ''
        a.download = `${clientName.replace(/[^a-zA-Z0-9]/g, '_')}_Estimate_${estNum}.pdf`
        document.body.appendChild(a)
        a.click()
        window.URL.revokeObjectURL(url)
        a.remove()
      })
      .catch(err => {
        console.error('PDF export failed:', err)
        setError('PDF export failed — check server logs')
      })
      .finally(() => setExporting(false))
  }

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') handleLoad()
  }

  return (
    <div>
      {/* Input bar */}
      <div style={{
        position: 'sticky',
        top: 0,
        zIndex: 100,
        background: '#1b3a5c',
        padding: '12px 24px',
        display: 'flex',
        alignItems: 'center',
        gap: 12,
        boxShadow: '0 2px 8px rgba(0,0,0,0.2)'
      }}>
        <span style={{ color: '#fff', fontFamily: 'DM Sans, sans-serif', fontSize: 14, fontWeight: 600 }}>
          Estimate Preview Test
        </span>
        <input
          type="text"
          value={input}
          onChange={(e) => setInput(e.target.value)}
          onKeyDown={handleKeyDown}
          placeholder="Estimate number or ID"
          style={{
            padding: '8px 12px',
            borderRadius: 4,
            border: 'none',
            fontSize: 14,
            fontFamily: 'DM Sans, sans-serif',
            width: 280,
            outline: 'none'
          }}
        />
        <button
          onClick={handleLoad}
          disabled={loading || !input.trim()}
          style={{
            padding: '8px 20px',
            borderRadius: 4,
            border: 'none',
            background: loading ? '#999' : '#d4a84b',
            color: '#fff',
            fontFamily: 'DM Sans, sans-serif',
            fontSize: 14,
            fontWeight: 600,
            cursor: loading ? 'wait' : 'pointer'
          }}
        >
          {loading ? 'Loading...' : 'Load'}
        </button>

        {/* Export PDF button — only visible when an estimate is loaded */}
        {data && data.estimate && (
          <button
            onClick={handleExportPdf}
            disabled={exporting}
            style={{
              padding: '8px 20px',
              borderRadius: 4,
              border: 'none',
              background: exporting ? '#999' : '#c62828',
              color: '#fff',
              fontFamily: 'DM Sans, sans-serif',
              fontSize: 14,
              fontWeight: 600,
              cursor: exporting ? 'wait' : 'pointer'
            }}
          >
            {exporting ? 'Generating PDF...' : 'Export PDF'}
          </button>
        )}

        {data && data.estimate && (
          <span style={{ color: '#d4a84b', fontFamily: 'DM Sans, sans-serif', fontSize: 13 }}>
            Loaded: #{data.estimate.number} — {data.estimate.name}
          </span>
        )}
        {error && (
          <span style={{ color: '#ff6b6b', fontFamily: 'DM Sans, sans-serif', fontSize: 13 }}>
            {error}
          </span>
        )}
      </div>

      {/* Preview */}
      {data && <EstimatePreviewPage preloadedData={data} />}

      {/* Empty state */}
      {!data && !loading && (
        <div style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: 'calc(100vh - 56px)',
          fontFamily: 'DM Sans, sans-serif',
          fontSize: 16,
          color: '#999',
          background: '#d4d0c8'
        }}>
          Enter an estimate number or ID above and click Load
        </div>
      )}
    </div>
  )
}

export default TestHarness
